/* Styles */
import "./modal3.css";
import classNames from "classnames";

function Modal3({
  isOpen,
  onClose,
  children,
  customStyles = {},
  customClassName = "",
  customHeight = "",
}) {
  const modalStyle = {
    display: isOpen ? "flex" : "none",
  };

  return (
    <div style={modalStyle} className="modal-wrapper3">
      <div
        className={classNames(
          "modal-wrapper3_content",
          customClassName
        )}
        style={customStyles}
      >
        <button
          type="button"
          onClick={onClose}
          className="sticky z-10 top-0 ml-auto text-white font-bold text-xl cursor-pointer w-8 min-h-8 rounded-1 flex justify-center items-center bg-DarkBlue-700"
          aria-label="close"
        >
          X
        </button>
        <div 
          className={classNames(
            "content-scroll w-full",
            customHeight
          )}
        >
          {children}
        </div>
      </div>
    </div>
  );
}

export default Modal3;
